import { Injectable } from '@angular/core';
import {GridColumn} from "@fgpp-ui/grid";
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";
import {QuickActions} from "../../models/enums/quick-actions.enum";


@Injectable({
  providedIn: 'root'
})
export class QuickActionsApiService {

  url = 'do/userQuickActions';

  constructor( protected http: HttpClient) { }

   getUserQuickActions():Observable<Array<QuickActions>>{
     return this.http.get<Array<QuickActions>>(this.url).pipe(
       catchError(error => {
         return throwError(() => error);
       })
     );
  }

   saveUserQuickActions(result: Array<GridColumn>){
    const userQuickActionList:string[] = result.map((gridColumn: GridColumn) =>gridColumn.name);
    return this.http.post<void>(this.url+'/save', userQuickActionList).toPromise();
  }

  deleteUserQuickActions(){
    return this.http.delete<void>(this.url).toPromise();
  }
}
